import React from 'react';
import { CameraOffIcon, InstagramIcon, MessageCircleWarningIcon, PaletteIcon, RepeatIcon, SearchXIcon, TrendingDownIcon, UserXIcon } from 'lucide-react';
import { CtaButton } from '../ui/CtaButton';
import { Eyebrow, Section } from '../ui/Section';
const pains = [{
  icon: SearchXIcon,
  title: 'No sabés el subtono',
  text: 'Sin un método claro desde el primer minuto.'
}, {
  icon: PaletteIcon,
  title: 'Corregís a ojo',
  text: 'Sin criterio técnico para elegir corrector.'
}, {
  icon: MessageCircleWarningIcon,
  title: 'El color no le sienta',
  text: 'Cuesta proponer una alternativa con seguridad.'
}, {
  icon: RepeatIcon,
  title: 'Siempre las mismas paletas',
  text: 'No adaptás el maquillaje a cada estación.'
}, {
  icon: UserXIcon,
  title: 'Pieles difíciles',
  text: 'Piel madura, acné o tonos extremos generan dudas.'
}, {
  icon: CameraOffIcon,
  title: 'Falla en fotos',
  text: 'La luz y el flash modifican el resultado.'
}, {
  icon: InstagramIcon,
  title: 'Tips sueltos',
  text: 'No tenés un sistema que respalde decisiones.'
}, {
  icon: TrendingDownIcon,
  title: 'No evolucionás',
  text: 'Seguís maquillando por intuición.'
}];
export function PainPoints() {
  return <Section className="bg-blush" data-id="element-187" data-mp="1x69am4w3sgj0">
      <div className="mx-auto max-w-2xl text-center" data-id="element-188" data-mp="1x57s5fcrcrr9">
        <Eyebrow data-id="element-189" data-mp="21wg0e82cq72u">¿Te pasa esto?</Eyebrow>
        <h2 className="mt-2 font-display text-3xl font-semibold leading-tight text-ink sm:mt-3 sm:text-4xl" data-id="element-190" data-mp="21xhmd7kwodzc">Si maquillás en Argentina, esto te suena familiar</h2>
      </div>

      <div className="mx-auto mt-6 max-w-3xl overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-rosegold/10 sm:mt-10 sm:rounded-3xl" data-id="element-191" data-mp="2awuvu09152k2">
        {pains.map(({
        icon: Icon,
        title,
        text
      }) => <div key={title} className="flex items-center gap-3 border-b border-blush px-3 py-2.5 last:border-b-0 sm:gap-4 sm:px-5 sm:py-3.5" data-id="element-192" data-mp="2kw3maj4orz1o">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-blush text-rosegold sm:h-10 sm:w-10 sm:rounded-xl" data-id="element-193" data-mp="lkaponlt8vph"><Icon className="h-4 w-4 sm:h-5 sm:w-5" strokeWidth={1.8} data-id="element-194" data-mp="igv5uoqf5zw7" /></span>
            <div className="min-w-0" data-id="element-195" data-mp="iixtj243ngxr"><h3 className="font-display text-base font-semibold leading-tight text-ink sm:text-lg" data-id="element-196" data-mp="ef9n4mr7ere3">{title}</h3><p className="mt-0.5 text-[11px] leading-snug text-plum sm:text-sm" data-id="element-197" data-mp="sf11wppjobt5">{text}</p></div>
          </div>)}
      </div>

      <div className="mt-7 text-center sm:mt-10" data-id="element-198" data-mp="newlt0sjtj3g"><p className="mb-4 font-display text-xl italic text-plum sm:mb-6 sm:text-3xl" data-id="element-199" data-mp="ni10is3n3x8d">¿Cuántas clientas más vas a diagnosticar a ojo?</p><CtaButton fullWidth={false} className="w-full sm:w-auto" data-id="element-200" data-mp="xedp5bkbvkw9">Quiero mi colorimetría resuelta</CtaButton></div>
    </Section>;
}